import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import "firebase/compat/storage";
import { connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBsrlus7_KfASOUYcbbM0z5zT3yv_uN5cs",
  authDomain: "apartmentvr-28fee.firebaseapp.com",
  databaseURL: "https://apartmentvr-28fee-default-rtdb.firebaseio.com",
  projectId: "apartmentvr-28fee",
  storageBucket: "apartmentvr-28fee.appspot.com",
  messagingSenderId: "906736138599",
  appId: "1:906736138599:web:ecf57dcf3c0851cadb57c2",
  measurementId: "G-XZJY87JSNV",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.database();
const firedb = firebase.firestore();
const auth = firebase.auth();
const functions = firebase.app().functions();
const storage = firebase.storage();

// if (window.location.hostname === "localhost") {
//   connectFunctionsEmulator(functions, "localhost", 5005);
// }

//connectFunctionsEmulator(functions, "localhost", 5001);

export { db, firedb, auth, firebase, functions, storage };
